/**
 * Inbox message clock — prefer ISO sentAt (UTC) rendered in the user's local timezone.
 */
export function formatMessageTime(msg) {
  if (msg?.sentAt) {
    const d = new Date(msg.sentAt);
    if (!Number.isNaN(d.getTime())) {
      return d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
    }
  }
  return msg?.time ?? "";
}
